// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","title":"Ge95a68 G8d5dc0 Gd71c60 G42bbcd G1b59f4 Ge28f91"};